import { AuthInfo } from 'src/types'

const appName = 'gea-user-app'
const authInfoStorageKey = 'authInfos'
const oldAuthInfoStorageKey = 'secretTwoFactor'

export const getUserSecret = (email: string): string => {
  const existingSecret = window.localStorage.getItem(oldAuthInfoStorageKey)
  if (existingSecret) {
    setUserSecret(email, existingSecret)
    window.localStorage.removeItem(oldAuthInfoStorageKey)
    return existingSecret
  }
  const authInfos: Array<AuthInfo> =
    JSON.parse(window.localStorage.getItem(authInfoStorageKey))

  if (!authInfos || !Array.isArray(authInfos)) return null

  const auth = authInfos.find((authInfo) => authInfo &&
    authInfo.secret &&
    authInfo.email === email.toLowerCase() &&
    authInfo.application === appName
  )

  return auth ? auth.secret : null
}

export const setUserSecret = (email: string, secret: string) => {
  const rawAuthInfos: Array<AuthInfo> =
      JSON.parse(window.localStorage.getItem(authInfoStorageKey))
  const existingAuthInfos = Array.isArray(rawAuthInfos) ? rawAuthInfos : []
  const authInfos = existingAuthInfos.filter(existingAuthInfo => existingAuthInfo.email !== email)
  window.localStorage.setItem(
    authInfoStorageKey,
    JSON.stringify([...authInfos, { email: email.toLowerCase(), secret, application: appName }])
  )
}

export const removeUserSecret = (email: string) => {
  window.localStorage.removeItem(oldAuthInfoStorageKey)

  const rawAuthInfos: Array<AuthInfo> = JSON.parse(window.localStorage.getItem(authInfoStorageKey))
  if (!Array.isArray(rawAuthInfos)) {
    return
  }

  const authInfos = rawAuthInfos.filter(existingAuthInfo => existingAuthInfo.email !== email.toLowerCase())
  window.localStorage.setItem(authInfoStorageKey, JSON.stringify(authInfos))
}
